import createDOMPurify from "dompurify";

const removeForbiddenTags = (value = "") =>
  String(value || "")
    .replace(/<script[\s\S]*?<\/script>/gi, "")
    .replace(/<iframe[\s\S]*?<\/iframe>/gi, "");

export const sanitizeHtml = (value = "") => {
  const normalized = String(value || "");
  const hasBrowserDom =
    typeof window !== "undefined" &&
    typeof document !== "undefined" &&
    typeof document.createElement === "function" &&
    typeof window.document !== "undefined";

  if (!hasBrowserDom) {
    return removeForbiddenTags(normalized);
  }

  const purifier =
    typeof createDOMPurify === "function"
      ? createDOMPurify(window)
      : createDOMPurify && typeof createDOMPurify.sanitize === "function"
        ? createDOMPurify
        : null;

  if (purifier && typeof purifier.sanitize === "function") {
    return purifier.sanitize(normalized, {
      USE_PROFILES: { html: true },
      FORBID_TAGS: ["script", "iframe"],
    });
  }

  return removeForbiddenTags(normalized);
};
